module.exports = __webpack_public_path__ + "static/media/illustration.fd81e73e.png";